<template>
    <SocketProvider>
      <component v-bind:is="layout">
      </component>
    </SocketProvider>
</template>

<script>
import DesktopLayout from './layouts/DesktopLayout.vue';
import LoginLayout from './layouts/LoginLayout.vue';
import ForgotPassword from './layouts/ForgotPassword.vue';
import UpdatePassword from './layouts/UpdatePasswordLayout.vue';
import SocketProvider from './api/SocketProvider';
import Vue from 'vue'
import vueCookie from "vue-cookie"
import VueAuthHref from 'vue-auth-href'
const options = {
  token: () => vueCookie.get('token')
}
Vue.use(VueAuthHref, options)
export default {
    name: 'App',
    computed: {
        layout() {
            return this.$store.getters.getLayout
        }
    },
    components: {
    'login-layout': LoginLayout,
    'desktop-layout': DesktopLayout,
    'forgot-password': ForgotPassword,
    'update-password-layout':UpdatePassword,
    SocketProvider
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue